import type { Module } from "@/lib/mapper/modules/types";
import type { Profile } from "@/lib/mapper/types";

export const variantsModule: Module = {
  id: "variants-shopify",
  name: "Variant Expander",
  description:
    "Generates one Shopify row per variant. Applies a per-variant price delta and SKU suffix. " +
    "Used today for the Stitched / Unstitched saree pattern.",
  glyph: "🔀",
  tone: "indigo",
  authoritative: false, // user may still want to set Option1 Linked To etc.
  ownedColumns(profile: Profile): string[] {
    if (!this.isActive(profile)) return [];
    // Option1 columns are written per-variant; we own them visually so the
    // user knows the variants module is doing the work.
    return ["Option1 Name", "Option1 Value"];
  },
  isActive(profile: Profile): boolean {
    return !!profile.variants?.enabled && (profile.variants?.options?.length ?? 0) > 0;
  },
  summarize(profile: Profile) {
    const v = profile.variants;
    if (!v) {
      return { text: "Variants disabled." };
    }
    const opts = v.options ?? [];
    const optList = opts
      .map((o) => `${o.value} (Δ ${o.priceDelta >= 0 ? "+" : ""}${o.priceDelta}, sku${o.skuSuffix})`)
      .join(", ");
    return {
      text: `Option "${v.optionName}" expands into ${opts.length} variant${opts.length === 1 ? "" : "s"} per product.`,
      bullets: [
        optList || "No variant options yet",
        v.applyTo?.length
          ? `Applies to: ${v.applyTo.join(", ")}`
          : "Applies to Variant Price, Variant SKU, Variant Compare At Price by default.",
      ],
    };
  },
};
